import React from 'react'
import { Button } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

const HelpLearnMore = ({ helpActionUrl }) => {
  const [t] = useTranslation()

  return (
    <Button to={helpActionUrl} target="_blank" rel="noopener noreferrer" external onClick={(e) => e.stopPropagation()}>
      {t('add-person.learn-more', 'Learn More')}
    </Button>
  )
}

export default HelpLearnMore
